import { get, post } from './api';
import { PaginatedResponse, CreateDonationTeamRequest } from '../types/api';
import { DonationTeam } from '../shared/models/DonationTeam';

export class DonationTeamService {
  static async createTeam(payload: CreateDonationTeamRequest): Promise<DonationTeam> {
    return post<DonationTeam>('/public/donation-teams', payload);
  }

  static async listProjectTeams(projectId: string, params?: { page?: number; limit?: number; openId?: string }): Promise<PaginatedResponse<DonationTeam>> {
    return get<PaginatedResponse<DonationTeam>>(`/public/projects/${projectId}/donation-teams`, params);
  }

  static async getProjectMyQuickTeams(projectId: string, openId: string): Promise<{ initiated: DonationTeam[]; joined: DonationTeam[] }> {
    return get<{ initiated: DonationTeam[]; joined: DonationTeam[] }>(`/public/projects/${projectId}/donation-teams/mine`, { openId });
  }

  static async joinTeam(teamId: string, openId: string): Promise<{ ok: boolean }> {
    return post<{ ok: boolean }>(`/public/donation-teams/${teamId}/join`, { openId });
  }

  static async getTeamById(teamId: string, openId?: string): Promise<DonationTeam> {
    return get<DonationTeam>(`/public/donation-teams/${teamId}`, openId ? { openId } : undefined);
  }

  static async listMyTeams(params: {
    openId: string;
    tab: 'initiated' | 'joined';
    page?: number;
    limit?: number;
    projectId?: string;
  }): Promise<PaginatedResponse<DonationTeam>> {
    return get<PaginatedResponse<DonationTeam>>('/public/my/donation-teams', params);
  }
}

